"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var classnames_1 = __importDefault(require("classnames"));
var form_footer_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/form_footer"));
var FormFooterStore = /** @class */ (function () {
    function FormFooterStore(props) {
        var _this = this;
        this.component = form_footer_1.default;
        this.isNextButtonEnabled = true;
        this.handleClickNextButton = function (event) {
            event.stopPropagation();
            event.preventDefault();
            _this.onClickNextButton();
        };
        this.handleClickPrevButton = function (event) {
            event.preventDefault();
            _this.onClickPrevButton && _this.onClickPrevButton();
        };
        this.onClickNextButton = props.onClickNextButton;
        this.description = props.description;
        this.onClickPrevButton = props.onClickPrevButton;
        this.abTestFormsVariant = props.abTestFormsVariant;
    }
    Object.defineProperty(FormFooterStore.prototype, "showsPrevButton", {
        get: function () {
            return Boolean(this.onClickPrevButton);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormFooterStore.prototype, "nextButtonClassNames", {
        get: function () {
            return (0, classnames_1.default)('estimateForm-FormFooter_NextButton', { 'estimateForm-FormFooter_NextButton-disabled': !this.isNextButtonEnabled });
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], FormFooterStore.prototype, "isNextButtonEnabled", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], FormFooterStore.prototype, "showsPrevButton", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], FormFooterStore.prototype, "nextButtonClassNames", null);
    return FormFooterStore;
}());
exports.default = FormFooterStore;
